/**
 * Author: Valeria Sinnati
 * ₍ᐢ. ̫.ᐢ₎  Chip di stato (ok/warn/off) per feature e badge: pillola.
 *
 * `accent` è un riempimento verde con testo Deep Purple e non più un testo
 * verde: su fondo chiaro il verde come testo non si legge. `muted` è la
 * pillola `soft`, neutra in entrambi i temi; success e warning restano tinte
 * leggere del loro colore, che è scuro in chiaro e chiaro in scuro.
 *
 * `hint` (Indigo) marca ciò che arriva dall'assistente o aspetta una sua
 * conferma, `strong` lo stato "in corso" dei mockup (tag-indigo, tag-strong):
 * prima le pagine li rifacevano con span locali, ognuno con le sue classi.
 */
import type { HTMLAttributes } from 'react'

export type ChipTone = 'success' | 'warning' | 'muted' | 'accent' | 'hint' | 'strong'

const tones: Record<ChipTone, string> = {
  success: 'text-success bg-success/12 border-success/30',
  warning: 'text-warning bg-warning/12 border-warning/30',
  muted: 'text-foreground bg-soft border-transparent',
  accent: 'text-on-accent bg-accent border-transparent',
  hint: 'text-on-hint bg-hint border-transparent',
  strong: 'text-on-strong bg-strong border-transparent',
}

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: ChipTone
}

/**
 *  /\____/\
 * > •    • <   #2
 */
export function Chip({ tone = 'muted', className = '', ...props }: ChipProps) {
  return (
    <span
      className={
        `inline-flex items-center gap-1 rounded-pill border px-2.5 py-0.5 ` +
        `text-xs font-semibold ${tones[tone]} ${className}`
      }
      {...props}
    />
  )
}
